import { atom } from "recoil";

const menuState = atom<{
    isDev: boolean;
    signed: any;
    nonSigned: any;
    current: any;
}>({
    key: "menuState",
    default: {
        isDev: false,
        signed: null,
        nonSigned: null,
        current: null,
    },
});

export default menuState;
